// @ts-nocheck
/* eslint-disable */
import Content from './content';
import { deferPromise } from "~/util/general";
import { IPoi } from "~/interfaces";
import { CONFIG } from "~/config";

function getLang() {
	const curLang = CONFIG.defaultLang;

	if (["cs", "sk"].includes(curLang)) {
		return "cs";
	}

	return "en";
}

/**
 * @class Hlavní obrázek detailu
 * @private
 */
export default class WindyWebCam extends Content {
	getPosterData() {
		return this._promiseData.promise;
	}

	_build() {
		this._promiseData = deferPromise();

		const data: IPoi["extend"]["webcamData"] = this._data;
		const iframe = document.createElement("iframe");
		const lang = getLang();

		iframe.allow = "fullscreen";
		iframe.classList.add("windy-webcam-iframe");
		iframe.src = `${data.player.day}&interactive=1&enabledTimelapses=day,month,year,lifetime&lang=${lang}`;
		this._promiseData.resolve([iframe, "windyWebcam"]);
	}
}
